import React, { createContext, useContext, useState, useEffect } from "react";
import firebase from "firebase/compat/app";

// Create context
const ComputerDataContext = createContext();

// Provider component
export const ComputerDataProvider = ({ userId, children }) => {
  const [computerData, setComputerData] = useState([]);
  const [loading, setLoading] = useState(true);

  const getComputerData = async (uid) => {
    try {
      const querySnapshot = await firebase
        .firestore()
        .collection("customers")
        .doc(uid)
        .collection("public_computers")
        .get();

      const resultat = querySnapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));

      return resultat || [];
    } catch (error) {
      console.error("Error fetching computer data:", error);
      return [];
    }
  };

  useEffect(() => {
    if (!userId) return;

    const fetchData = async () => {
      setLoading(true);
      const data = await getComputerData(userId);
      setComputerData(data);
      setLoading(false);
    };

    fetchData();
  }, [userId]);

  return (
    <ComputerDataContext.Provider value={{ computerData, loading }}>
      {children}
    </ComputerDataContext.Provider>
  );
};

// Custom hook to use the context
export const useComputerData = () => useContext(ComputerDataContext);
